import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { saveAs } from 'file-saver';

/**
 *  現在スタックされているデータをCSVに変換してダウンロードする
 */
export class CreateCsvUseCase {
  /**
   * Execute
   * @param data - 現在スタックされているデータ
   * @param fileName - ダウンロードするファイル名
   */
  public Execute = async (data: string[][], fileName: string): Promise<INetworkResult<void, Error>> => {
    try {
      //文字列型で二次元配列のデータ

      //作った二次元配列をTSV文字列に直す。
      let csvString = '';
      for (const d of data) {
        const csvValue = d.map((value) => _escapeCsvValue(value));
        csvString += csvValue.join(',');
        csvString += '\r\n';
      }

      //ファイル名の指定
      const outputFileName = fileName + '.csv';

      //CSVのバイナリデータを作る
      //バイナリ文字セットの'UTF-8'のエンコードを追加する
      //Microsoft言語のBOMバイナリUnicodeである文字列「\uFEFF」を追加する
      const blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8' });
      const uri = URL.createObjectURL(blob);

      saveAs(blob, outputFileName);
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('保存に失敗しました'),
        },
      };
    }
  };
}

/**
 * CSV出力する文字列などの情報にカンマ、改行、ダブルクオートのような
 * エスケープするべき情報が含まれていた場合、エスケープした情報を返す
 * @param value - エスケープする情報
 * @returns エスケープした文字列
 */
const _escapeCsvValue = (value: string | number): string => {
  if (typeof value === 'string') {
    // ダブルクオートをエスケープ
    value = value.replace(/"/g, '""');
    // カンマや改行がある場合はダブルクオートで囲む
    if (value.includes(',') || value.includes('\n')) {
      value = `"${value}"`;
    }
  }
  return String(value);
};
